/*eslint-disable*/
import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
//import FormControlLabel from "@material-ui/core/FormControlLabel";
// material ui icons
import MailOutline from "@material-ui/icons/MailOutline";
import Slider from "nouislider";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import Datetime from "react-datetime";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import axios from "../../utils/axiosInstance";
import defaultImage from "assets/img/image_placeholder.jpg";
import defaultAvatar from "assets/img/placeholder.jpg";
// style for this view
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import reactDom from "react-dom";
import RichTextEditor from "react-rte";

import SweetAlert from "react-bootstrap-sweetalert";
//const baseURL = "https://jsonplaceholder.typicode.com/api/v1/admin/login";
const useStyles = makeStyles(styles);
import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import { CircularProgress } from "@material-ui/core";
//const baseURL = "https://jsonplaceholder.typicode.com/api/v1/admin/login";
const useStyleData = makeStyles(stylesData);


export default function TermsOfUse() {
  let fileInput = React.createRef();

  const [formValues, setFormValues] = React.useState({
    title: " ",
    detail: ""
  });
  const [editorBody, setEditorBody] = React.useState(RichTextEditor.createEmptyValue());
  const [loading, setLoading] = React.useState(true);
  const [alert, setAlert] = React.useState(null);

  const handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.id]: e.target.type === 'number' ? Number(e.target.value) : e.target.value,
    });
    console.log(formValues);
  };

  React.useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      setLoading(true);
      try {
        await axios
          .get(
            `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/termuse`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Access-Control-Allow-Origin": "*",
              },
            }
          )
          .then((res) => {
            const data = res.data.data;
            setFormValues({
              title: data[0]?.title,
              detail: data[0]?.detail
              //setImageName(data[0]?.image);
            });
            setEditorBody(RichTextEditor.createValueFromString(data[0].detail, 'html'));
          });
      } catch (error) {
        console.error(error.message);
        if (error?.response?.data?.message == "For security reasons, we locked your account.Please login to continue") {
          localStorage.removeItem("token");
          window.location.assign("/auth/login-page");
        }
      }
      setLoading(false);
    };

    fetchData();
  }, []);

  const hideAlert = () => {
    setAlert(null);
    window.location.reload()
  };

  const handleSubmitForm = async () => {
    const token = localStorage.getItem("token");
    const newFormValue = Object.assign(formValues);
    axios.put(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/termuse`,
      newFormValue,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        }
      }
    ).then((res) => {
      setAlert(
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={
            <span
              style={{
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              {res?.data.message}
            </span>
          }
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          titleCssClass={classesSweetAlert.cardTitle}
          confirmBtnCssClass={
            classesSweetAlert.button + " " + classesSweetAlert.success
          }
        />
      );


    })
      .catch((err) => {
        console.warn(err);

      })
  };
  const handleEditorChange = (newValue) => {
    setEditorBody(newValue);
    setFormValues({
      ...formValues,
      "detail": newValue.toString("html"),
    });

  };

  const classes = useStyles();
  const classesSweetAlert = useStyleData();
  return (
    <div>

      {!loading ? (
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <MailOutline />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Terms of Use</h4>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <CustomInput
                        labelText="Title"
                        id="title"
                        handleChange={handleChange}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          value: formValues?.title,
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12}>
                      <RichTextEditor
                        value={editorBody}
                        onChange={handleEditorChange}
                        style={{ height: "300px" }}
                      />
                    </GridItem>
                  </GridContainer>
                  {alert}
                  <Button
                    color="rose"
                    className={classes.registerButton}
                    onClick={handleSubmitForm}
                  >
                    Submit
                  </Button>
                </form>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      ) : (<div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </div>)}
    </div>
  );
}
